import styled from 'styled-components'

export const ScaleLine = styled.hr`
  position: absolute;
  margin: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 2px;
  border: none;
  background-color: ${o => o.theme.color.deprecated.stone};
  width: 100%;
  z-index: ${o => o.theme.zIndex.backgroundContent};
`

export const ScalePoint = styled.div`
  height: 24px;
  width: 24px;
  background-color: ${o => o.theme.color.deprecated.stone};
  border-radius: 50%;
  position: relative;
  z-index: ${o => o.theme.zIndex.page};
`

export const ScaleWrapper = styled.div<{
  highlightChild: number
}>`
  height: 24px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  position: relative;

  ${({ highlightChild, theme }) => `
    ${ScalePoint}:nth-of-type(${highlightChild}) {
      background-color: ${theme.color.deprecated.obsidian};
  `}
`
